export const amenitiesResaleReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_RESALE_AMENITIES_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        amenitiesResale: null,
      };

    case "GET_RESALE_AMENITIES_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        amenitiesResale: action.payload,
      };

    case "GET_RESALE_AMENITIES_LIST_FAILED":
      return {
        ...state,
        loading: false,
        amenitiesResale: action.payload,
      };

    case "GET_RESALE_SUB_AMENITIES_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        subAmenities: null,
      };

    case "GET_RESALE_SUB_AMENITIES_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        subAmenities: action.payload,
      };

    case "GET_RESALE_SUB_AMENITIES_LIST_FAILED":
      return {
        ...state,
        loading: false,
        subAmenities: action.payload,
      };

    case "GET_RESALE_AMENITY_REQUEST":
      return {
        ...state,
        loading: true,
        amenity: null,
      };

    case "GET_RESALE_AMENITY_SUCCESS":
      return {
        ...state,
        loading: false,
        amenity: action.payload,
      };

    case "GET_RESALE_AMENITY_FAILED":
      return {
        ...state,
        loading: false,
        amenity: action.payload,
      };

    case "ADD_RESALE_AMENITIES_REQUEST":
      return {
        ...state,
        loading: true,
        amenities: null,
      };

    case "ADD_RESALE_AMENITIES_SUCCESS":
      return {
        ...state,
        loading: false,
        amenities: action.payload,
      };

    case "ADD_RESALE_AMENITIES_FAILED":
      return {
        ...state,
        loading: false,
        amenities: action.payload,
      };

    case "EDIT_RESALE_AMENITIES_REQUEST":
      return {
        ...state,
        loading: true,
      };

    case "EDIT_RESALE_AMENITIES_SUCCESS":
      return {
        ...state,
        loading: false,
        amenities: action.payload,
      };

    case "EDIT_RESALE_AMENITIES_FAILED":
      return {
        ...state,
        loading: false,
        amenities: action.payload,
      };

    default:
      return state;
  }
};